export default __webpack_public_path__ + "static/media/avocado_sandwich.293fdc84.jpg";